import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'byteToSize', standalone: true })
export class ByteToSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (!bytes && bytes !== 0) {
      return '';
    }
    if (bytes === 0) {
      return '0 Byte';
    }

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Math.round(bytes / 1024 ** i)} ${sizes[i]}`;
  }
}
